import { useAuth } from "../hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

const PRIVATE = [
  "dashboard",
  "cooperatives",
  "subscriptions",
  "modules",
  "sms-messaging",
  "profile",
  "member",
  "transaction-history",
  "settlement",
];

export const AuthGuard = ({ children }) => {
  const path = useLocation().pathname;
  const navigate = useNavigate();
  const auth = useAuth();
  const isLoggedIn = !!auth;

  const isPrivate = PRIVATE.some((route) => path.includes(route));

  useEffect(() => {
    if (isPrivate && !isLoggedIn) {
      navigate("/login", { replace: true });
    }
  }, [isPrivate, isLoggedIn, navigate]);

  return <>{children}</>;
};
